import { render } from "./FooterBar.vue?vue&type=template&id=354df670&scoped=true"
const script = {}

import "./FooterBar.vue?vue&type=style&index=0&id=354df670&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354df670"]])

export default __exports__